import { Button, Grid, useTheme } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';

function HomePageAssing() {
    const navigate = useNavigate();

    const { tokens } = useTheme();

    const handleAssingPageToForm = () => {
        navigate("/admin/assing/form");
    };

    return (
        <div className="container">
            <Grid
                templateColumns="1fr"
                templateRows="3rem"
                gap={tokens.space.small}
            >
                <Button
                    variation="primary"
                    colorTheme="success"
                    onClick={handleAssingPageToForm}
                    className='button-create'
                >
                    Asignar un proyecto
                </Button>
            </Grid>
        </div>
    );
}

export default HomePageAssing;
